<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      class="text-center"
      justify="center"
    >
      <v-col
        v-if="sessionExp"
        cols="12"
      >
        <v-alert type="warning">
          {{ msgError }}
        </v-alert>
      </v-col>
      <template v-if="loading">
        <v-card
          class="elevation-4 mx-auto"
          min-width="300"
          max-width="800"
        >
          <v-col cols="12">
            <Load :loading-msg="loadingMsg" />
          </v-col>
        </v-card>
      </template>
      <template v-else>
        <v-card
          class="elevation-4 mx-auto pa-6"
          min-width="300"
          max-width="800"
        >
          <div>
            <img
              src="@/assets/keystone-logo.png"
              width="200px"
            >
            <div
              class="text-h4"
              style="color: #606263;"
            >
              Intranet
            </div>
          </div>
          <div class="mt-6">
            <v-text-field
              id="login"
              ref="login"
              v-model="login"
              prepend-icon="mdi-account"
              label="E-mail"
              @keydown.enter="$refs.password.focus()"
            />
          </div>
          <div class="mt-6">
            <v-text-field
              ref="password"
              v-model="password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              label="senha"
              @click:append="showPassword = !showPassword"
              @keydown.enter="loginIntranet"
            />
          </div>
          <div class="mt-6">
            <v-btn
              block
              color="primary"
              @click="loginIntranet()"
            >
              Entrar
            </v-btn>
          </div>
        </v-card>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import Load from '@/components/Loading.vue'
export default {
  layout: 'auth',

  components: {
    Load
  },

  data () {
    return {
      loading: false,
      msgError: '',
      loadingMsg: '',
      login: '',
      showPassword: false,
      password: '',
      sessionExp: false
    }
  },
  created () {
    this.verifyLogin()
  },

  mounted () {
    this.$refs.login.focus()
  },

  methods: {
    async loginIntranet () {
      this.loading = true
      this.loadingMsg = 'Verificando usuário e senha'
      const data = {
        email: this.login,
        password: this.password
      }
      try {
        await this.$api.getCookie(data)
      } catch {
      }
      this.getError()
      this.$router.push({ name: 'painel' })
      this.loading = false
    },
    getError () {
      this.msgError = localStorage.getItem('Error')
      this.sessionExp = true
    },
    verifysession () {
      if (this.$store.state.error.status === true) {
        this.msgError = this.$store.state.error.msg
        this.sessionExp = true
      }
    },
    async verifyLogin () {
      this.verifysession()
      if (this.$store.state.intranetUser) {
        this.$router.push({ name: 'painel' })
      }
      // const request = await this.$api.me()
      // this.loading = false
      // if (request === true) {
      //   this.$router.push({ name: 'painel' })
      // }
    }
  }
}
</script>
